"use strict";

exports.__esModule = true;
exports.default = void 0;
var fontUrl = 'https://www.ewe.at/gui/styleguide/project/old/brands/_image-strivers/fonts/fs-lola/';
var eweFonts = "\n @font-face {\n   font-family: 'Tahoma';\n }\n @font-face {\n   font-weight: 200;\n   font-family: 'Tahoma';\n }\n @font-face {\n   font-weight: 700;\n   font-family: 'Tahoma';\n }\n ";
var _default = exports.default = eweFonts;